import { Component, OnChanges, SimpleChanges, input, signal } from '@angular/core';
import { IEventInfoResourceResponseBm, LocationStateEnum } from '@outlook-addin/cue-http';
import { translation } from '@cue/translations';

import { cueArrowDown, IconComponent } from '@cue/ui/icons';
import { ResourceDetailComponent } from '../resource-detail/resource-detail.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'addin-location-detail',
  templateUrl: './location-detail.component.html',
  styleUrls: ['./location-detail.component.scss'],
  imports: [ResourceDetailComponent, TranslocoPipe, IconComponent],
})
export class LocationDetailComponent implements OnChanges {
  ICONS = {
    cueArrowDown,
  };
  translation = translation;

  protected locationStateEnum = LocationStateEnum;
  protected expandedResourceIds = signal<Set<string>>(new Set());

  resourceList = input<IEventInfoResourceResponseBm[]>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['resourceList']) {
      const resourceList = this.resourceList() ?? [];
      const resourceIdList = resourceList.map((resource) => resource.guid);

      if (resourceIdList.length === 1) {
        this.expandedResourceIds.set(new Set(resourceIdList));
        return;
      }

      this.expandedResourceIds.update((expandedResourceIds) => {
        return new Set([...expandedResourceIds].filter((resourceId) => resourceIdList.includes(resourceId)));
      });
    }
  }

  isItemExpanded(resourceId: string) {
    return this.expandedResourceIds().has(resourceId);
  }

  expandShrinkGroup(resourceId: string) {
    this.expandedResourceIds.update((expandedResourceIds) => {
      const nextExpandedResourceIds = new Set(expandedResourceIds);
      if (nextExpandedResourceIds.has(resourceId)) {
        nextExpandedResourceIds.delete(resourceId);
      } else {
        nextExpandedResourceIds.add(resourceId);
      }

      return nextExpandedResourceIds;
    });
  }
}
